import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  cookieYesSelectors = ['div[id^="cky-"]', 'div[class*="cky-"]'];

  connect() {
    this.moveCookieYesToPermanentContainer();
    
    this.handleCookiePolicyContainer();

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (this.isCookieYesElement(node)) {
            this.moveCookieYesToPermanentContainer();
            this.handleCookiePolicyContainer();
          }
        });
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    ['turbo:load', 'turbo:render', 'turbo:before-cache'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        this.moveCookieYesToPermanentContainer();
        this.handleCookiePolicyContainer();
      });
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  moveCookieYesToPermanentContainer() {
    const container = document.getElementById('cookieyes-container');
    if (!container) return;

    this.cookieYesSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (!container.contains(element) && element.id !== 'cookieyes-container') {
          container.appendChild(element);
        }
      });
    });
  }

  isCookieYesElement(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) return false;
    return this.cookieYesSelectors.some(selector => element.matches(selector));
  }

  handleCookiePolicyContainer() {
    const policyContainer = document.getElementById('cky-policy-container');
    const policyHeading = document.getElementsByClassName('cookie-policy-h1')[0];
    
    if (policyContainer) {      
      if (policyHeading) {
        policyHeading.classList.add('hidden');
      }

      const currentPath = window.location.pathname;
      policyContainer.style.display = currentPath.includes('/cookie-policy/') 
        ? 'block' 
        : 'none';
    }
  }
}

